module.exports = __webpack_public_path__ + "media/images/icons/outlined/line-35dbdf4bb55004e3fb6314c1cdd72efe.svg";